import { render, staticRenderFns } from "./ConnectionDocsSentToPartner.vue?vue&type=template&id=31d63939&scoped=true"
import script from "./ConnectionDocsSentToPartner.vue?vue&type=script&lang=js"
export * from "./ConnectionDocsSentToPartner.vue?vue&type=script&lang=js"
import style0 from "./ConnectionDocsSentToPartner.vue?vue&type=style&index=0&id=31d63939&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d63939",
  null
  
)

export default component.exports